import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PaginatedSearchFilter } from '../interfaces/paginated-search-filter';
import { AuditReportDto } from '../interfaces/audit-report-dto';
import { PaginatedSearchResponse } from '../interfaces/paginated-search-response';
import { envToken } from '../tokens/env-token';

@Injectable({
    providedIn: 'root'
})
export class AuditReportService {
    private http = inject(HttpClient);
    private env = inject(envToken);


    baseUrl = '';

    constructor() {
        this.baseUrl = this.env.apiUrl + '/api/v1/audit-report';
    }

    getByEnterpriseId(sourceSystem: string, enterpriseId: number, filter: PaginatedSearchFilter):
        Observable<PaginatedSearchResponse<AuditReportDto>> {
        const headers = new HttpHeaders().set('Content-Type', 'application/json');
        const params = new HttpParams()
            .set('page', filter.page)
            .set('size', filter.itemsPerPage)
            .set('sort', filter.sortBy + ',' + filter.sortOrder);
        return this.http.get<PaginatedSearchResponse<AuditReportDto>>(`${this.baseUrl}/${ sourceSystem }/${enterpriseId}`, { headers, params });
    }

    isReportNameUnique(sourceSystem: string, enterpriseId: number, reportName: string): Observable<boolean> {
        return this.http.post<boolean>(`${this.baseUrl}/${ sourceSystem }/${enterpriseId}/validate-report-name`, {}, { params: { reportName: reportName } });
    }

    sendRequest(auditReport: Partial<AuditReportDto>) {
        return this.http.post<void>(`${this.baseUrl}/send-request`, auditReport);
    }

    getCsv(sourceSystem: string, fileName: string): Observable<string> {
        return this.http.get<string>(`${this.baseUrl}/${sourceSystem}/get-csv/${fileName}`, {
            responseType: 'text' as 'json'
        });
    }

}
